import { Link } from 'gatsby';
import React from 'react';
import circleStripe from '../assets/images/circle-stripe.png';
import category1 from '../assets/images/categories/1.jpeg';
import category2 from '../assets/images/categories/2.jpeg';
import category3 from '../assets/images/categories/3.jpeg';
import category4 from '../assets/images/categories/4.jpeg';

const CourseCatThree = () => {
  return (
    <section className='course-category-three'>
      <img
        src={circleStripe}
        className='course-category-three__circle'
        alt=''
      />
      <div className='container'>
        <div className='block-title'>
          <h2 className='block-title__title'>
            Browse our <br />
            current programs
          </h2>
        </div>
        <div className='row'>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className='course-category-three__single'>
              <img src={category1} alt='' />
              <div className='course-category-three__content'>
                <h3 className='course-category-three__title'>
                  <Link to='/courses'>Post Basic Nursing </Link>
                </h3>
                <p className='course-category-three__text'>Over 3 Courses</p>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className='course-category-three__single'>
              <img src={category2} alt='' />
              <div className='course-category-three__content'>
                <h3 className='course-category-three__title'>
                  <Link to='/course/comm-health'>School of Community Health </Link>
                </h3>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className='course-category-three__single'>
              <img src={category3} alt='' />
              <div className='course-category-three__content'>
                <h3 className='course-category-three__title'>
                  <Link to='/course/health-info-nd'>School of Health Information Management</Link>
                </h3>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className='course-category-three__single'>
              <img src={category4} alt='' />
              <div className='course-category-three__content'>
                <h3 className='course-category-three__title'>
                  <Link to='/course/bio-med-nd'>Federal School of Biomedical Engineering</Link>
                </h3>
              </div>
            </div>
          </div>
          <div className='col-lg-3 col-md-6 col-sm-12'>
            <div className='course-category-three__single'>
              <img src={category4} alt='' />
              <div className='course-category-three__content'>
                <h3 className='course-category-three__title'>
                  <Link to='/course/bio-med-nd'>Biomedical Engineering</Link>
                </h3>
              </div>
            </div>
          </div>
        </div>
        <div className='text-center'>
          <Link
            to='/courses'
            className='thm-btn course-category-three__more-link'
          >
            View All Programs
          </Link>
        </div>
      </div>
    </section>
  );
};

export default CourseCatThree;
